/**
 * Loan Repayment Schedules list — landed in R1 at
 * /operations/loans/schedules.
 *
 * R1 scope: page shell + route. The DataTable view of next-due
 * installments across all in-repayment loans lands in R3 (M16
 * retrofit). For now it points HR at the per-application detail
 * drawer which already shows the schedule.
 */

import { CalendarRange } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  EmptyState,
  OperationsReportsButton,
  PageHeader,
} from "../components/ui";
import { HrInitiateLink } from "../components/hr_operations";

export function LoanSchedulesPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title={t("operations.loan_schedules_title")}
        breadcrumbs={[
          { label: t("nav.operations"), href: "/operations" },
          { label: t("nav.loans"), href: "/loans/applications" },
          { label: t("operations.loan_schedules_breadcrumb") },
        ]}
        actions={
          <div className="flex items-center gap-2">
            <HrInitiateLink transactionType="loan" />
            <OperationsReportsButton
              domain="loans"
              domainLabel={t("nav.loans", "Loans")}
            />
          </div>
        }
      />
      <EmptyState
        icon={CalendarRange}
        headline={t("operations.loan_schedules_title")}
        description={t("operations.loan_schedules_placeholder")}
      />
    </div>
  );
}
